import { defineStore } from 'pinia';
import services from '@/services';
import useApi from '@/hooks/useApi';
import useInfo from './info';
import utils from '@/utils/index';
import { Status } from '@/types/enums';
const { getParam } = utils;
interface AnniversaryState {
  comic: {
    backgroundLandscape: string;
    backgroundPortrait: string;
    coverLandscape: string;
    coverPortrait: string;
    introduction: string;
    status: Status;
    unlockTime: number;
  } | null;
  anniversaryVideos: {
    coverLandscape: string;
    coverPortrait: string;
    status: Status;
    youtubeId: string;
    title: string;
    unlockTime: number;
  }[];
  scheduleEvents: {
    title: string;
    startTime: number;
    endTime: number;
    prizeImage: string;
    prizeName: string;
    status: Status;
    deeplink: string;
  }[];
  ingameVideos: {
    coverLandscape: string;
    coverPortrait: string;
    status: Status;
    unlockTime: number;
    youtubeId: string;
    title: string;
  }[];
  chosenIngameVideo: {
    coverLandscape: string;
    coverPortrait: string;
    status: Status;
    unlockTime: number;
    youtubeId: string;
    title: string;
  };
  chosenIngameVideoIndex: number;
  isInitialized: boolean;
  chosenScheduleItem: number;
}

const anniversaryState = (): AnniversaryState => ({
  comic: null,
  anniversaryVideos: [],
  scheduleEvents: [],
  ingameVideos: [],
  chosenIngameVideo: {
    coverLandscape: '',
    coverPortrait: '',
    status: 0,
    unlockTime: 0,
    youtubeId: '',
    title: '',
  },
  chosenIngameVideoIndex: 0,
  isInitialized: false,
  chosenScheduleItem: 0,
});

const useAnniversary = defineStore('anniversary', {
  state: anniversaryState,
  getters: {
    firstEventIndex: (state) => {
      const events = [...state.scheduleEvents]
      const index = events.findIndex(item => item.status === Status.Open);
      return index;
    }
  },
  actions: {
    async getAnniversary() {
      const { lang, region } = useInfo();
      if (!lang || !region) return;
      const accessToken =
        getParam('access_token') || localStorage.getItem('TOKEN');
      const response = await useApi(() =>
        services.getAnniversary({ lang, region, ...(accessToken && { accessToken }) }),
      );
      if (!response || response.msg) return;
      const { data } = response;
      this.$patch({ ...data });
      this.chooseScheduleItem(this.firstEventIndex);
      this.setIsInitialized(true);
    },
    setIsInitialized(boolean: boolean) {
      this.isInitialized = boolean;
    },
    chooseIngameVideo(data: AnniversaryState['chosenIngameVideo']) {
      this.chosenIngameVideo = data;
    },
    chooseIngameVideoIndex(index: number) {
      this.chosenIngameVideoIndex = index;
    },
    chooseScheduleItem(index: number) {
      this.chosenScheduleItem = index;
    },
  },
});

export default useAnniversary;
